import api from '@/apis/index'
const state = {
  userlists: [],
  transitionName: 'slide-none',
  device: '',
  selfOrTeam:'self', //预约类型: 默认个人预约   self个人 team团队  intergrated预约机
  isWeixin:(function(){return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1})(),
  token: localStorage.getItem('token') || '',
  maxNum : 10000, //预约数量
  idCard:'',//身份证号
  mobile:'',//手机号
  // idCard:'513902198908192710',//身份证号
}

const mutations = {
  SET_device: (state, device) => {
    state.device = device
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_transitionName: (state, name) => {
    state.transitionName = name
  },
  SET_userList: (state, lists) => {
    state.userlists = lists
  },
  SET_userinfo: (state, data) => {
    state.userlists[data.swiperindex][data.userindex] = {
      name: data.name,
      idCard: data.idCard,
      face_image: data.face_image
    }
  },
  SET_selfOrTeam: (state, data) => {
    state.selfOrTeam = data
  },
  SET_maxNum: (state, count) => {
    state.maxNum = count
  },
  SET_idCard: (state, idCard) => {
    state.idCard = idCard
  },
  SET_mobile: (state, mobile) => {
    state.mobile = mobile
  },

}

const actions = {
  changeDevice ({commit, state, dispatch}, device) {
    commit('SET_device', device);
  },
  saveList ({commit, state, dispatch}, data) {
    return new Promise((resolve, reject) => {
      let lists = [];
      if (data && Number(data) !== 0) {
        for (let i = 0; i < Math.floor(data / 3); i++) {
          lists.push([{}, {}, {}])
        }
        if (data % 3) {
          let arr = []
          for (let i = 0; i < data % 3; i++) {
            arr.push({})
          }
          lists.push(arr)
        }
        commit('SET_userList', lists);
      }
      resolve(lists)
    })
  },
  // 退出登录
  saveUser ({commit, state, dispatch}, data) {
    return new Promise((resolve, reject) => {
      commit('SET_userinfo', data);
      resolve(state.userlists)

    })
  },
  changeTransition ({commit, state, dispatch}, name) {
    commit('SET_transitionName', name);
  },
  changeSelfOrTeam ({commit, state, dispatch}, data) {
    return new Promise((resolve, reject) => {
      commit('SET_selfOrTeam', data);
      resolve(state.selfOrTeam)
    })
  },
  async userLogin ({commit, state, dispatch}, code) {
    let {msg:token} = await api.getUserInfo(code)
    if (token) {
      localStorage.setItem('token', token)
      commit('SET_TOKEN', token)
    }
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js
